module.exports = __webpack_public_path__ + "img/404.c7aa1de7.svg";